module.exports = __webpack_public_path__ + "static/media/ic_calculator_grey.da3a4fa0.svg";